import LineItems from "./LineItems";
import Expenses from "./Expenses";
import Subcontracts from "./Subcontracts";

export default function LineItemsTab() {
  return (
    <>
      <LineItems />
      <div className="pt-4 mt-4 border-top border-top-dashed">
        <Expenses />
      </div>
      <div className="pt-4 mt-4 border-top border-top-dashed">
        <Subcontracts />
      </div>
    </>
  );
}
